import React from 'react';
import fr from 'facet-rest';
import { pick } from 'Helpers/Affordances';
import NullComponent from 'Components/UI/NullComponent';
import useQueryParams from 'Hooks/useQueryParams';
import { LearnMore, SHOW_TAX_LEARN_MORE_QUERY_PARAM } from '../LearnMore';
import { HeroLoader } from './HeroLoader';

export const MainContent = ({ resource }) => {
  const [queryParams] = useQueryParams();
  const preferLearnMore = queryParams.get(SHOW_TAX_LEARN_MORE_QUERY_PARAM) === 'true';
  const Component = pick(
    resource,
    preferLearnMore
      ? {
        [fr.relationships.learnMore.name]: LearnMore,
        [fr.relationships.hero.name]: HeroLoader,
        [fr.relationships.filingHero.name]: HeroLoader,
      }
      : {
        [fr.relationships.hero.name]: HeroLoader,
        [fr.relationships.filingHero.name]: HeroLoader,
        [fr.relationships.learnMore.name]: LearnMore,
      },
    NullComponent,
  );
  return <Component resource={resource} />;
};
